import { http } from '@/providers/apis/http';
import { learnerSerializer } from '@/providers/serializers/learners/learners';
import LearnerModel from '@/models/learners/learner';
export class RegistryAPI {

  private static INSTANCE = new RegistryAPI();

  static get instance() {
    return this.INSTANCE;
  }

  public fetchRegistryList() {
      const endpoint = `${window.location.origin}/stubs/registry.json`;
      const headers = http.getTokenHeaders();
      return http.get(endpoint, headers).then((response) => {
          return response.data;
      });
  }

}

export const registryAPI = RegistryAPI.instance;
